import { API_BASE_URL } from '@/constants/api'

export interface CloudFileItem {
  id: number
  shareId: string
  shareKey: string
  shareName: string
  fileId: string // 文件ID（用于单个文件下载和删除）
  displayName: string
  originalName: string
  fileSize: number
  contentType: string
  fileType: string
  createdAt: string
  downloadUrl: string
  passwordLocked: boolean
}

export interface CloudFileResponse {
  items: CloudFileItem[]
  total: number
  page: number
  pageSize: number
  totalPages: number
}

interface ErrorResponse {
  error?: string
  message?: string
}

export async function getCloudFiles(page: number = 1, pageSize: number = 24): Promise<CloudFileResponse> {
  const token = localStorage.getItem('accessToken')

  if (!token) {
    throw new Error('未登录')
  }

  const response = await fetch(`${API_BASE_URL}/cloud/files?page=${page}&pageSize=${pageSize}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    let message = '加载云盘文件失败'
    try {
      const error: ErrorResponse = await response.json()
      if (error.error || error.message) {
        message = error.error || error.message!
      }
    } catch (err) {
      // ignore parse error
    }
    throw new Error(message)
  }

  return response.json()
}

export function formatFileSize(size: number): string {
  if (!size || size <= 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  const index = Math.floor(Math.log(size) / Math.log(1024))
  const value = size / Math.pow(1024, index)
  return `${value.toFixed(value >= 10 ? 0 : 2)} ${units[index]}`
}

/**
 * 删除云盘中的单个文件
 */
export async function deleteCloudFile(shareId: string, fileId: string): Promise<void> {
  const token = localStorage.getItem('accessToken')

  if (!token) {
    throw new Error('未登录')
  }

  const response = await fetch(`${API_BASE_URL}/history/transfers/${shareId}/files/${fileId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    let message = '删除文件失败'
    try {
      const error: ErrorResponse = await response.json()
      if (error.error || error.message) {
        message = error.error || error.message!
      }
    } catch (err) {
      // ignore parse error
    }
    throw new Error(message)
  }
}
